import api from "./api";

export const transferSummaryService = {

  // 📊 Get full location summary (locationFlow + netStock)
  // params: { year, month, startDate, endDate } — all optional
  getSummary: async (params = {}) => {
    try {
      const response = await api.get("/transfer-summary", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 📋 Get bike list currently at a specific location
  // params: { location (required), year, month, startDate, endDate }
  getDetail: async (params = {}) => {
    try {
      const response = await api.get("/transfer-summary-detail", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};